/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaCittadinoCapabilitiesDTO { 
    can_edit?: boolean;
    can_edit_reason?: string;
    can_verify_otp?: boolean;
    can_verify_otp_reason?: string;
}

